import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1141. 支払タスク管理会計確認チェック編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/update_accounting_confirmed
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  accounting_confirmed: boolean;
};

const updatePaymentTaskAccountingConfirmed = (props: Props): Promise<PaymentTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/update_accounting_confirmed`,
    props
  );
};

export const useUpdatePaymentTaskAccountingConfirmed = () => {
  return useMutation({
    mutationFn: updatePaymentTaskAccountingConfirmed,
  });
};
